var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTellFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9999 11C18.9999 15.4183 15.4182 19 10.9999 19C9.20353 19 7.54545 18.4079 6.21016 17.4083L2.59717 18.6788L4.04303 14.9528C3.37913 13.7868 2.99988 12.4377 2.99988 11C2.99988 6.58172 6.58161 3 10.9999 3C15.4182 3 18.9999 6.58172 18.9999 11ZM7.75 12C8.30228 12 8.75 11.5523 8.75 11C8.75 10.4477 8.30228 10 7.75 10C7.19772 10 6.75 10.4477 6.75 11C6.75 11.5523 7.19772 12 7.75 12ZM12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 10.4477 12 11ZM14.25 12C14.8023 12 15.25 11.5523 15.25 11C15.25 10.4477 14.8023 10 14.25 10C13.6977 10 13.25 10.4477 13.25 11C13.25 11.5523 13.6977 12 14.25 12Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellFilledIcon);
export default __webpack_public_path__ + "static/media/TellFilledIcon.fb787d1fa6e12d59e2706209a482d2da.svg";
export { ForwardRef as ReactComponent };